export function updatePriority(formName, priorityRank, networkDisplayPathModifierId) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'SET_PRIORITY',
                formName,
                networkDisplayPathModifierId,
                priorityRank,
            })
        );
}

export function updatePriorityOnDrag(formName, destination, source) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'SET_PRIORITY_ON_DRAG',
                formName,
                destination,
                source,
            })
        );
}
